<div class="lpx-mobile-navbar-container">
  <div class="lpx-mobile-navbar">
    <div class="lpx-mobile-nav-tab-left">
      <ul class="lpx-mobile-nav-tabs justify-content-center">
        @if (adminNavItem && adminNavItem?.children?.length) {
          <li
            class="lpx-mobile-nav-tab"
            [class.selected]="activeMenu === adminNavItem.text"
            (click)="toggleMenu(adminNavItem.text, adminNavItem.children)"
          >
            <a class="lpx-mobile-nav-item">
              <lpx-icon
                class="menu-item-icon"
                [iconClass]="adminNavItem.icon"
              ></lpx-icon>
              <span class="mobile-item-text">
                {{ adminNavItem.text! | lpxTranslate | async }}
              </span>
            </a>
          </li>
        } @else if (adminNavItem) {
          <li
            class="lpx-mobile-nav-tab"
            [routerLink]="adminNavItem?.link"
            [routerLinkActive]="adminNavItem?.link ? 'selected' : ''"
            [routerLinkActiveOptions]="{ exact: adminNavItem.link === '/' }"
            [class.selected]="adminNavItem?.expanded"
            (click)="closeMenu()"
          >
            <a class="lpx-mobile-nav-item">
              @if (adminNavItem.icon) {
                <lpx-icon
                  class="menu-item-icon"
                  [iconClass]="adminNavItem.icon"
                ></lpx-icon>
              }
              <span class="mobile-item-text">
                {{ adminNavItem.text }}
              </span>
            </a>
          </li>
        }

          @if (leilaoNavItem  && leilaoNavItem?.children?.length) {
            <li
              class="lpx-mobile-nav-tab"
              [class.selected]="activeMenu === leilaoNavItem.text"
              (click)="toggleMenu(leilaoNavItem.text, leilaoNavItem.children)"
            >
              <a class="lpx-mobile-nav-item">
                <lpx-icon
                  class="menu-item-icon"
                  [iconClass]="leilaoNavItem.icon"
                ></lpx-icon>
                <span class="mobile-item-text">
                  {{ leilaoNavItem.text! | lpxTranslate | async }}
                </span>
              </a>
            </li>
          } @else if (leilaoNavItem) {
            <li
              class="lpx-mobile-nav-tab"
              [routerLink]="leilaoNavItem?.link"
              [routerLinkActive]="leilaoNavItem?.link ? 'selected' : ''"
              [routerLinkActiveOptions]="{ exact: leilaoNavItem.link === '/' }"
              [class.selected]="leilaoNavItem?.expanded"
              (click)="closeMenu()"
            >
              <a class="lpx-mobile-nav-item">
                @if (leilaoNavItem.icon) {
                  <lpx-icon
                    class="menu-item-icon"
                    [iconClass]="leilaoNavItem.icon"
                  ></lpx-icon>
                }
                <span class="mobile-item-text">
                  {{ leilaoNavItem.text }}
                </span>
              </a>
            </li>
          }
      </ul>
    </div>

    <div class="lpx-mobile-nav-tab-center">
      <a
        class="lpx-mobile-hamburger"
        [ngClass]="toggleClass"
        (click)="toggleNavbarMenu()"
      >
        <span
          class="hamburger-icon"
          aria-hidden="true"
          [class.lpx-mobile-menu-opn]="activeMenu === 'navbar'"
        >
          <span class="icon-part"></span>
          <span class="icon-part"></span>
          <span class="icon-part"></span>
          <span class="icon-part"></span>
          <span class="icon-part"></span>
          <span class="icon-part"></span>
        </span>
      </a>
    </div>

    <div class="lpx-mobile-nav-tab-right">
      <ul class="lpx-mobile-nav-tabs justify-content-center">
        <li
          class="lpx-mobile-nav-tab"
          (click)="triggerOpenPanel()"
        >
          <a class="lpx-mobile-nav-item">
            <app-notification-bell></app-notification-bell>
            <span class="mobile-item-text">
              Notificações
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>


  <div class="lpx-mobile-menu" [hidden]="!menuVisible">
    <div class="lpx-logo-container">
      <div class="lpx-header-top">
        <lpx-brand-logo></lpx-brand-logo>
        @if (isAuthenticated()) {
      <div
        class="lpx-mobile-nav-tab"
        [class.selected]="activeMenu === 'profile'"
        (click)="toggleMenu('profile', profileMenuItems)"
      >
        <a class="lpx-mobile-nav-item">
          <lpx-avatar [avatar]="avatar()"></lpx-avatar>
          <span class="mobile-item-text">{{ userName() }}</span>
        </a>
      </div>
    }
      </div>
    </div>



    <lpx-navbar-routes
      [navbarItems]="selectedMenuItems"
      [groupedItems]="groupedItems$ | async"
      (routeClick)="closeMenu()"
    >
    </lpx-navbar-routes>

    @if (activeMenu === 'profile') {
      <hr class="my-2 mx-2 mr-2" />
      <lpx-mobile-toolbar
        [items]="toolbarService.items$ | async"
        (routeClick)="closeMenu()"
      >
      </lpx-mobile-toolbar>
    }
  </div>
</div>
